import { Button, Container, Typography } from '@/ui-kit';
import { AvatarProfile } from './components/avatar-profile';
import { useAuth } from '@/store/useAuth';
import styles from './settings-profile.module.scss';
import { differenceInYearsResult } from '@/utils/difference-in-years-result';
import { routesApp } from '@/constans/routes';
import { format } from 'date-fns';
import { IconTg, RemoderationIcon, ModerationPendingIcon, CheckIcon } from '@/assets/icons';
import { ru } from 'date-fns/locale';
import WebApp from '@twa-dev/sdk';
import { useEffect, useState } from 'react';
import { jwtService } from '@/services/jwt.service';
import { SocketPayload } from '@/types/socket-payload';
import { useActionCableCreate } from '@/hooks/use-action-cable';
import { ProfileActiveSection } from '../profile-active-section/profile-active-section';
import { HalfDone } from '../half-done';
import { ProfileVerificationSection } from '../profile-verification-section/profile-verification-section';
import { getProfileNameAndAge, localizeDate } from '@/utils/msgs';
import { Trans, useTranslation } from 'react-i18next';
import { useLogProfileChannelRejection } from '@/hooks/use-log-profile-channel-rejection';
import { PremiumBanner } from '../premium-banner';

export const SettingsProfile: React.FC = () => {
    const CHANEL_NAME = 'ProfileChannel';
    let chanel: any;
    const isDev = process.env.NODE_ENV === 'development';
    const getPathFromWebSocketUrlIsDev = (url: string) => {
        if (isDev) {
            // const parsedUrl = new URL(url);
            // return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
            // TODO: url to env
            return 'http://localhost:8255/cable';
            // return 'http://localhost:3300/cable';
        }
        return url;
    };
    const cable = useActionCableCreate(
        getPathFromWebSocketUrlIsDev('/cable')
    );

    const userData = useAuth((state) => state.getUser());    
    const { setProfile } = useAuth((state) => state);

    const { t, i18n } = useTranslation();

    const openLink = () => {
        WebApp.openTelegramLink('https://t.me/euphora_support')
    }

    const { logProfileChannelRejection } = useLogProfileChannelRejection()

    useEffect(() => {

        chanel = cable.subscriptions.create(
            {
                channel: CHANEL_NAME,
                authentication: WebApp.initData.length ? WebApp.initData : jwtService.getAccessToken(),
            },
            {
                connected() {
                    console.log('connected setting');
                },
                received(payload: SocketPayload) {


                    switch (payload.type) {
                        case 'subscription_updated':
                            setProfile({
                                ...userData,
                                ...payload.data.profile
                            })
                            break;
                    }
                },
                disconnected() {
                    console.log('WebSocket отключён. Пытаемся переподключиться...');
                },
                rejected() {
                    console.log('Сервер отклонил подписку!');
                    logProfileChannelRejection({ channel: CHANEL_NAME })
                },
            },
        );
    }, []);

    return (
        <Container className={styles.container}>
            <AvatarProfile
                name={
                    getProfileNameAndAge(userData)
                }
                avatar={userData?.photos?.[0]?.thumb_url?.toString()} />

            {
                (
                    userData
                        ?.moderation_status
                        === 'change_required' &&
                    userData
                        ?.violations_resolved === false
                ) &&
                <div className={styles.remoderationCard}>
                    <div className={styles.remoderationCardContent}>
                        <RemoderationIcon className={styles.remoderationCardContentIcon} />
                        <Typography
                            fontWeight="semibold"
                            className={styles.remoderationCardContentTitle}
                            center>
                            <Trans i18nKey="please_edit_your_details" />
                        </Typography>
                        <Typography center>
                            {t('passing_verification_note')}
                        </Typography>
                    </div>
                    <Button
                        typeColor='orange'
                        to={routesApp.profileEdit}
                        isLink
                        className={styles.remoderationCardBtn}>
                        {t('go_to_profile')}
                    </Button>
                </div>
            }

            {
                userData?.state === 'half_done' &&
                <HalfDone />
            }

            {
                (
                    userData
                        ?.moderation_status
                        === 'change_required' &&
                    userData
                        ?.violations_resolved
                ) &&
                <div className={styles.remoderationCard}>
                    <div className={styles.remoderationCardContent}>
                        <ModerationPendingIcon className={styles.remoderationCardContentIcon} />
                        <Typography
                            fontWeight="semibold"
                            className={styles.remoderationCardContentTitle}
                            center>
                            {t('your_profile_is_being_reviewed')}
                        </Typography>
                        <Typography center>
                            {t('we_are_currently_checking_your_info')}
                        </Typography>
                    </div>
                </div>
            }

            <div className={styles.support}>
                <div>
                    <p>{t('profile.support')}</p>
                    <IconTg width={25} height={25} />
                </div>
                <span onClick={openLink}>@euphora_support</span>
            </div>

            {
                userData?.is_paid ?
                    (
                        <div className={styles.activatedPremiumCard}>
                            <div className={styles.activatedPremiumCardMain}>
                                <Typography
                                    fontWeight="bold"
                                    variant="h2"
                                    className={styles.activatedPremiumCardTitle}
                                    center>
                                    Euphora Premium
                                </Typography>
                                <Button className={styles.activatedPremiumCardBtn}>
                                    {
                                        t(
                                            'profile.active_until',
                                            { date: localizeDate(userData?.paid_till) }
                                        )
                                    }
                                </Button>
                            </div>
                            <ul className={styles.activatedPremiumCardBenefits}>
                                <li className={styles.activatedPremiumCardBenefit}>
                                    <Typography
                                        fontWeight="semibold"
                                        variant="h6"
                                        className={styles.activatedPremiumCardBenefitTitle}
                                        center>
                                        {t('view_likes')}
                                    </Typography>
                                    <CheckIcon width={20} height={20} />
                                </li>
                                <li className={styles.activatedPremiumCardBenefit}>
                                    <Typography
                                        fontWeight="semibold"
                                        variant="h6"
                                        className={styles.activatedPremiumCardBenefitTitle}
                                        center>
                                        {t('high_priority')}
                                    </Typography>
                                    <CheckIcon width={20} height={20} />
                                </li>
                            </ul>
                        </div>
                    )
                :
                    <PremiumBanner />
            }

            {
                userData?.verification_status === 'unverified' &&
                <ProfileVerificationSection />
            }
            
            <ProfileActiveSection />
        </Container>
    );
};
